import { Build, Component, Element, h, Host, State } from '@stencil/core';

@Component({
  tag: 'mama-fachbereichsnavigation',
})
export class MamaFachbereichsnavigation {
  @Element() el: HTMLElement;

  @State() showArrow: 'left' | 'right' | false = false;

  container: HTMLElement;
  private scrollAnchor!: HTMLElement;
  private scrollObserver!: IntersectionObserver;

  componentWillLoad() {
    const hero = this.el.closest('.hero');

    if (hero) {
      hero.classList.add('has-fachbereichsnavigation');
      const buehne = hero.querySelector('.buehne');

      if (buehne) {
        if (buehne.classList.contains('treelevel-0')) {
          hero.classList.add('has-treelevel-0');
        }
        if (buehne.classList.contains('treelevel-1')) {
          hero.classList.add('has-treelevel-1');
        }
        if (buehne.classList.contains('treelevel-2')) {
          hero.classList.add('has-treelevel-2');
        }
      }
    }
  }

  componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }

    this.scrollAnchor = document.getElementById('fachbereichsnavigation-id') as HTMLElement;
    this.scrollObserver = this.initializeScrollObserver();

    this.container = this.el.querySelector('.container > .nav-wrapper');

    const containerWidth = this.container.clientWidth;
    const navItems = this.el.querySelectorAll('a');

    let navItemsWidth = 0;
    navItems.forEach(navItem => {
      navItemsWidth += navItem.clientWidth;
    });

    if (navItemsWidth > containerWidth) {
      this.showArrow = 'right';
      this.isActiveVisible();
    }
  }

  disconnectedCallback() {
    this.scrollObserver.unobserve(this.scrollAnchor);
  }

  initializeScrollObserver() {
    if (this.scrollObserver instanceof IntersectionObserver) {
      this.scrollObserver.unobserve(this.scrollAnchor);
    }

    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          if (this.scrollAnchor.getBoundingClientRect().top < window.innerHeight) {
            this.el.classList.add('fachbereichsnavigation-sticky');
          }
        } else {
          this.el.classList.remove('fachbereichsnavigation-sticky');
        }
      });
    });
    scrollObserver.observe(this.scrollAnchor);

    return scrollObserver;
  }

  isActiveVisible() {
    const activeItem = this.el.querySelector('a.active');
    if (!activeItem) {
      return;
    }

    if (activeItem.getBoundingClientRect().right > this.container.getBoundingClientRect().right) {
      this.scrollRight();
    }
  }

  scrollRight() {
    this.container.scrollTo({ left: this.container.scrollWidth, behavior: 'smooth' });
    this.showArrow = 'left';
  }

  scrollLeft() {
    this.container.scrollTo({ left: 0, behavior: 'smooth' });
    this.showArrow = 'right';
  }

  render() {
    return (
      <Host class="fachbereichsnavigation">
        <div class="container">
          <div class="arrow-wrapper arrow-wrapper-left" hidden={this.showArrow !== 'left'} onClick={_ => this.scrollLeft()}>
            <svg class="arrow-right">
              <use xlinkHref="#arrow-right" />
            </svg>
          </div>

          <nav class="nav-wrapper">
            <slot />
          </nav>

          <div class="arrow-wrapper arrow-wrapper-right" hidden={this.showArrow !== 'right'} onClick={_ => this.scrollRight()}>
            <svg class="arrow-right">
              <use xlinkHref="#arrow-right" />
            </svg>
          </div>
        </div>
      </Host>
    );
  }
}
